export default "__VITE_ASSET__DFHzaFvw__"